import { message } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { logOut } from '../authentication/actionCreator';
import { getItem } from '../../utility/localStorageControl';

const {
  mailReadBegin,
  mailReadSuccess,
  mailReadErr,

  mailAddBegin,
  mailAddSuccess,
  mailAddErr,

  getmailReadBegin,
  getmailReadSuccess,
  getmailReadErr,

  getLeavesReadBegin,
  getLeavesReadSuccess,
  getLeavesReadErr,

  getLeavesRequestReadBegin,
  getLeavesRequestReadSuccess,
  getLeavesRequestReadErr,

  LeaveUpdateUpdateBegin,
  LeaveUpdateUpdateSuccess,
  LeaveUpdateUpdateErr,

  getLeavesDataReadBegin,
  getLeavesDataReadSuccess,
  getLeavesDataReadErr,

} = actions;

const getLeavesDataRequestData = () => {
  return async (dispatch) => {
    try {
      await dispatch(getLeavesDataReadBegin());
      const response = await DataService.get(`Holidays`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(getLeavesDataReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(getLeavesDataReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(getLeavesDataReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(getLeavesDataReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
}

const getLeavesRequestRequestData = () => {
  return async (dispatch) => {
    try {
      await dispatch(getLeavesRequestReadBegin());
      const response = await DataService.get(`compose-mail/LeavesRequest`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(getLeavesRequestReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(getLeavesRequestReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(getLeavesRequestReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(getLeavesRequestReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
}


const mailDataRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(mailReadBegin());
      const response = await DataService.get(`/push-notifications/`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(mailReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(mailReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(mailReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(mailReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};


const mailDataSubmit = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(mailAddBegin());

      const fd = new FormData();
      fd.append("subject", data.subject || "");
      fd.append("description", data.description || "");
      fd.append("dates", JSON.stringify(data.dates || []));
      fd.append("leaveType", data.leaveType || "");

      if (data.attachment) {
        fd.append("attachment", data.attachment);
      }

      const response = await DataService.blob("POST", "/compose-mail/create", fd, {
        "Content-Type": undefined,
      });

      const token = getItem("access_token");
      if (token && response !== null && response.data.Error === false) {
        await dispatch(mailAddSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(mailAddSuccess(null));
      } else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(mailAddSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(mailAddErr(err));
      message.error(err.message === "Network Error" ? "Server is down, please contact developer team" : err.message);
      if (err.message === "Network Error") dispatch(logOut());
    }
  };
};


const getLeavesData = () => {
  return async (dispatch) => {
    try {
      await dispatch(getmailReadBegin());
      const response = await DataService.get(`compose-mail`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(getmailReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(getmailReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(getmailReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(getmailReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};


const getEmployeeLeavesData = (scope = null) => {
  return async (dispatch) => {
    try {
      await dispatch(getLeavesReadBegin());
      const url = scope ? `compose-mail/leaves?scope=${encodeURIComponent(scope)}` : `compose-mail/leaves`;
      const response = await DataService.get(url);
      const token = getItem('access_token');

      if (token && response !== null && response.data.Error === false) {
        await dispatch(getLeavesReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(getLeavesReadSuccess(null));
      } else {
        if (response?.data?.Error === true && response?.data?.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(getLeavesReadSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(getLeavesReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team");
        dispatch(logOut());
      } else {
        message.error(err.message);
      }
    }
  };
};


const updateLeaveRequestRequestData = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(LeaveUpdateUpdateBegin());
      const response = await DataService.put(`/compose-mail/update`, data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(LeaveUpdateUpdateSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(LeaveUpdateUpdateSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(LeaveUpdateUpdateSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(LeaveUpdateUpdateErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};


export {
  mailDataSubmit,
  mailDataRead,
  getLeavesData,
  getEmployeeLeavesData, getLeavesRequestRequestData, updateLeaveRequestRequestData, getLeavesDataRequestData
};
